import type {MemberTeamsQuery} from "../types/teamMember.dto";
import type {GlobalPersonalizationState} from "@atg-tillsammans-shared/personalization-data-access";

export const TEAM_MEMBER_SLICE_NAME = "teamMember";

export type FetchMemberTeamsPayload = {
    refreshTeams?: boolean;
};

export type SetMemberTeamsPayload = {
    data: MemberTeamsQuery;
    cachedAt: number;
};

export interface TeamMemberState {
    teams: {data: MemberTeamsQuery | null; cachedAt: number | null};
}

export type GlobalTeamMemberState = GlobalPersonalizationState & {
    [TEAM_MEMBER_SLICE_NAME]: TeamMemberState;
};
